export default __webpack_public_path__ + "static/media/dr-kusuma.805ae00d.jpg";